/**
 * Copyright (C) 2017-2018 System Clinic Inc. All rights reserved.
 * This file is the property of System Clinic Inc.
 *
 * File: SignupConfirm.js
 * Author: Naoaki Suganuma
 * Update: 2018/3/12
 * Version: 1.0.0
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import ValidatorGroup from '../validation/ValidatorGroup';
import TextFieldValidator from '../validation/TextFieldValidator';
import Typography from '@material-ui/core/Typography';
import { grey } from '@material-ui/core/colors';
import withStyles from '@material-ui/core/styles/withStyles';
import withTheme from '../withTheme';
import { registerIfNeeded } from '../actions/auth';

/**
 * スタイル情報 
 */
const styles = theme => ({
  base: {
    flex: "1 1 auto",
    display: "flex",
    position: "relative",
    overflow: "hidden",
  },
  frameDesktop: {
    minWidth: 480,
    maxWidth: 540,
    height: 'auto',
    position: 'absolute',
    top: '20%',
    left: 0,
    right: 0,
    margin: 'auto',
  },
  frameMobile: {
    width: '100%',
    height: '100%',
    display: "flex",
    flexDirection: 'column',
    justifyContent: 'space-around'
  },
  paper: {
    padding: 30,
    overflow: 'auto',
  },
  paperMobile: {
    flex: "0 0 auto",
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: 20,
    paddingRight: 20,
    overflow: 'auto',
  },
  section100: {
    width: "100%",
    marginTop: 20
  },
  section100Mobile: {
    width: "100%",
    marginTop: 3
  },
  sectionTitle: {
    fontSize: "0.75em",
    color: grey[700],
  },
  sectionData: {
    height: 28,
    margin: "4px 0px 0px 0px",
    fontSize: "1.0em",
    color: grey[700],
    borderBottom: "solid 1px #ddd"
  },
  textField: {
    marginLeft: 0,
    width: "100%",
  },
  register: {
    float: 'right',
    marginTop: 30,
    width: 200,
  },
  registerMobile: {
    float: 'right',
    marginTop: 15,
    width: 200,
  },
  aux: {
    paddingTop: 50,
    textAlign: "center"
  },
  auxMobile: {
    flex: "0 0 100px",
    paddingTop: 15,
    textAlign: "center"
  },
  error: {
    width: "100%",
    textAlign: "center",
    margin: "15px 0px",
    padding: "5px 0",
    border: "solid 3px",
    borderColor: theme.palette.error.light,
    borderRadius: "3px"
  },
  errorMobile: {
    width: "100%",
    textAlign: "center",
    margin: "5px 0px",
    padding: "5px 0",
    border: "solid 3px",
    borderColor: theme.palette.error.light,
    borderRadius: "3px"
  },
  errorText: {
    width: "100%",
    textAlign: "center",
    marginTop: 3
  },});

/**
 * SignupConfirmコンポーネント
 */
class SignupConfirm extends Component {
  /**
    * コンストラクタ
    */
  constructor(props) {
    super(props);
    var token = this.getToken(props.history.location.search);
    var payload = this.decodeToken(token);
    this.state = {
      token: token,
      email: payload != null ? payload.email : null,
      name: "",
      nameEmpty: false,
      password: "",
      passwordConfirm: "",
      passwordEmpty: false,
      passwordsNotMatch: false,
      groupValid: false
    };
  }

  /**
   * モバイル画面かどうかを判定する。
   */
  isMobile = () => {
    if (window.matchMedia && window.matchMedia('(max-width:767px)').matches) {
      return true;
    } else {
      return false;
    }    
  }

  /**
   * クエリ文字列からトークンを取得する。
   * @param {*} search  クエリ文字列
   */
  getToken(search) {
    try {
      var hash = search.slice(1).split('&');
      if (hash.length > 0) {
        var keyValue = hash[0].split('=');
        if (keyValue.length === 2) {
          return keyValue[1];
        }
      }
    } catch (e) {
    }
    return null;
  }

  /**
   * JWTトークンを解析する。
   * @param {*} token 
   */
  decodeToken(token) {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
    }
    return null;
  }

  /**
   * 氏名が変更された時に呼び出されるハンドラ
   */
  handleNameChange = (event) => {
    this.setState({
      name: event.target.value,
      nameEmpty: false
    });
  }

  /**
   * パスワードが変更された時に呼び出されるハンドラ
   */
  handlePasswordChange = (event) => {
    this.setState({
      password: event.target.value,
      passwordEmpty: false,
      passwordsNotMatch: false
    });
  }

  /**
   * 確認用パスワードが変更された時に呼び出されるハンドラ
   */
  handlePasswordConfirmChange = (event) => {
    this.setState({
      passwordConfirm: event.target.value,
      passwordEmpty: false,
      passwordsNotMatch: false
    });
  }

  /**
   * p1yが変更された時に呼び出されるハンドラ
   * @param {object} event 
   */
  handleGroupValidation = (validationResult) => {
    let valid = true;
    for (let result of validationResult) {
      valid &= result.valid;
    }
    this.setState({ groupValid: valid });
  }

  /**
   * サインアップボタンがクリックされた時に呼び出されるハンドラ
   */
  handleRegisterButtonClick = (event) => {
    if (this.isEmpty(this.state.name)) {
      this.setState({ nameEmpty: true });
    } else if (this.state.password !== this.state.passwordConfirm) {
      this.setState({ passwordsNotMatch: true })
    } else if (this.isEmpty(this.state.password)) {
      this.setState({ passwordEmpty: true })
    } else {
      this.props.registerIfNeeded(this.state.token, this.state.email, this.state.password, this.state.name);
    }
  }

  /*
   * 空文字かどうかの判定
   */
  isEmpty(value) {
    if (value === undefined || value == null) {
      return true;
    }
    if (typeof value === 'string') {
      return value.trim() === '' || value.trim().length === 0;
    }
    return false;
  }

  /**
   * エラーメッセージを取得する。
   * @param {エラー}} error 
   */
  getErrorMessage(error) {
    if (error === "exists") {
      return "ユーザはすでに登録されています。";
    } else if (error === "expired") {
      return "有効期限が切れています。再度ユーザ登録からやり直してください。";
    } else {
      return "エラーが発生しました。再度ユーザ登録を行ってください。";
    }
  }

  /**
   * 登録用のコンポーネントを返す
   */
  getRegisterComponents() {
    return (
      this.state.token == null || this.state.email == null ?
        <Paper className={this.props.classes.paper}>
          <Typography variant={this.isMobile() ? "subtitle2" : "subtitle1"}>
            指定したアドレスは有効な情報ではありません。メールで送られてきたアドレスを間違いがないようにコピーし、再度ブラウザで開いてください。
          </Typography>
        </Paper>
        :
        <Paper className={this.isMobile() ? this.props.classes.paperMobile : this.props.classes.paper}>
            {
              this.state.nameEmpty ?
              <div className={this.isMobile() ? this.props.classes.errorMobile : this.props.classes.error}>
                <Typography variant={this.isMobile() ? "subtitle2" : "subtitle1"} color="error" className={this.props.classes.errorText}>氏名を入力してください</Typography>
              </div>
              : null
            }
            {
              this.state.passwordEmpty ?
              <div className={this.isMobile() ? this.props.classes.errorMobile : this.props.classes.error}>
                <Typography variant={this.isMobile() ? "subtitle2" : "subtitle1"} color="error" className={this.props.classes.errorText}>パスワードを入力してください</Typography>
              </div>
              : null
            }
            {
              this.state.passwordsNotMatch ?
              <div className={this.isMobile() ? this.props.classes.errorMobile : this.props.classes.error}>
                <Typography variant={this.isMobile() ? "subtitle2" : "subtitle1"} color="error" className={this.props.classes.errorText}>確認用パスワードが一致しません</Typography>
              </div>
              : null
            }
            {
              this.props.registerationError != null ?
              <div className={this.isMobile() ? this.props.classes.errorMobile : this.props.classes.error}>
                <Typography variant={this.isMobile() ? "subtitle2" : "subtitle1"} color="error" className={this.props.classes.errorText}>{this.getErrorMessage(this.props.registerationError)}</Typography>
              </div>
              : null
            }
            {
              this.isMobile() ?
                <Typography variant="subtitle2">
                  氏名とパスワードを設定し、登録ボタンを押してください。
                </Typography> :
                <Typography variant="subtitle1">
                  氏名とパスワードを設定し、正式登録を行います。確認用パスワードにはパスワードと同じものを入力してください。すべての項目を入力し、登録ボタンを押してください。
                </Typography>
            }
            <div className={this.isMobile() ? this.props.classes.section100Mobile : this.props.classes.section100} >
              <div className={this.props.classes.sectionTitle}>仮登録メールアドレス</div>
              <div className={this.props.classes.sectionData}>{this.state.email}</div>
            </div>
            <TextField
              value={this.state.name}
              label="氏名"
              margin={this.isMobile() ? "dense" : "normal"}
              fullWidth={true}
              onChange={(event) => this.handleNameChange(event)}
            />
            <ValidatorGroup
              validatorGroupListener={this.handleGroupValidation}
            >
              <TextFieldValidator
                name="password"
                type="password"
                value={this.state.password}
                label="パスワード"
                onChange={this.handlePasswordChange}
                fullWidth
                margin={this.isMobile() ? "dense" : "normal"}
                validators={['minStringLength:8']}
                errorMessages={['8文字以上のパスワードが必要です']}
              />
              <TextFieldValidator
                name="passwordConfirm"
                type="password"
                value={this.state.passwordConfirm}
                label="パスワード（確認）"
                onChange={this.handlePasswordConfirmChange}
                fullWidth
                margin={this.isMobile() ? "dense" : "normal"}
                validators={['minStringLength:8']}
                errorMessages={['8文字以上のパスワードが必要です']}
              />
            </ValidatorGroup>
            <Button
              variant="contained"
              color="primary"
              disabled={!this.state.groupValid}
              className={this.isMobile() ? this.props.classes.registerMobile : this.props.classes.register}
              onClick={this.handleRegisterButtonClick}
            >
              登録
            </Button>
          </Paper>
      );
  }

  /**
   * 登録完了後のコンポーネントを返す
   */
  getCompleteComponents() {
    return (
      <Paper className={this.props.classes.paper}>
        <Typography variant="subtitle1">
         登録が完了しました。ログイン画面から登録したメールアドレスとパスワードでログインしてください。
        </Typography>
      </Paper>
    );
  }

  /**
   * Signupコンポーネントのレンダリング
   */
  render() {
    return (
      <div className={this.props.classes.base}>
        <div className={this.isMobile() ? this.props.classes.frameMobile : this.props.classes.frameDesktop}>
          { 
            this.props.registerComplete ? this.getCompleteComponents() : this.getRegisterComponents()
          }
          <div className={this.isMobile() ? this.props.classes.auxMobile : this.props.classes.aux}>
            <Button
              component={Link} to="/"
              color="primary"
            >
              ログイン画面に戻る
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * StoreをPropsにマップする。
 * @param {*} state 
 */
function mapStateToProps(state) {
  return state.auth;
}

/**
 * Dispatcherをマップする。
 * @param {*} dispatch 
 */
function mapDispatchToProps(dispatch) {
  return {
    registerIfNeeded: (token, email, password, name) => {
      dispatch(registerIfNeeded(token, email, password, name))
    }
  }
}

/**
 * reduxとの接続
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTheme(withStyles(styles)(SignupConfirm)))